import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/tokens.css'
import './styles/status-colors.css'
import './styles/base.css'
// MUST stay above './App'. This captures `next` and `type` out of the callback
// URL before the Supabase client consumes the callback and rewrites the address
// bar. Moving or removing this import breaks the return-URL round trip in a way
// that only shows up on a real sign-in.
import './auth/initial-callback'
import { App } from './App'

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
